import store from '@/store';
import _ from 'lodash';
import keys from '@/store/keys';
// import oLocalStorage from '@/services/objectLocalStorage';
import { EventBus } from '@/services/eventBus';
// import oLocalStorage from '@/services/objectLocalStorage';

export default {
  async getCityByUrl(start) {
    // if (oLocalStorage.get('citySelected') === null || oLocalStorage.get('langSelected') === null) {
    let hostname = document.location.hostname;
    let city = _.find(store.state.citiesArray, itCity => {
      return hostname.indexOf(_.toLower(itCity.alias)) > -1 || hostname.indexOf(_.toLower(itCity.code)) > -1;
    });

    if (typeof city !== 'undefined') {
      store.commit('CITY_SELECTED', {
        city: city
      });

      this.getLaunchLanguage(city);
    }
    // }
    start(store);
  },

  getLaunchLanguage(city) {
    let defaultLangSelected = null;

    let isEnglish = document.URL.match(/\.com(:{1}\d+)?\/en/);
    let isCatalan = document.URL.match(/\.com(:{1}\d+)?\/ca/);
    let hasLanguage = document.URL.match(/\.com(:{1}\d+)?\/[a-z]+/);

    if (isEnglish !== null) {
      defaultLangSelected = _.find(store.state.countrySelected.languages, it => it.lang === 'en');
    } else if (isCatalan !== null) {
      defaultLangSelected = _.find(store.state.countrySelected.languages, it => it.lang === 'ca');
      if (typeof defaultLangSelected === 'undefined') {
        defaultLangSelected = city.defaultLanguage;
      }
    } else if (hasLanguage !== null) {
      defaultLangSelected = _.find(store.state.countrySelected.languages, it => it.lang === 'es');
    } else {
      defaultLangSelected = city.defaultLanguage;
    }

    EventBus.$emit(keys.citySelected);

    store.commit('CHANGE_LANG_SELECTED', {
      langSelected: defaultLangSelected.langIso,
      url: document.URL
    });
  }
};
